function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Platform } from "react-native";
import { Login } from "./Login";
import { RequestResetPassword } from "./RequestResetPassword";
import { ResetPassword } from "./ResetPassword";
import { SignUp } from "./SignUp";
/**
 * Mounts various auth related screens needed for an app.
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-176}
 */ export function Auth(param) {
    var $t = param.$t, Screen = param.Screen, theme = param.scheme;
    var options = {
        headerRight: function() {
            return null;
        },
        headerStyle: [
            {
                borderBottomWidth: 0,
                backgroundColor: theme === 'dark' ? 'black' : 'white'
            },
            Platform.OS === 'web' ? {
                boxShadow: undefined
            } : {
                shadowOpacity: 0,
                elevation: 0
            }
        ]
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Screen, {
                name: "Login",
                component: Login,
                options: _object_spread_props(_object_spread({}, options), {
                    headerTitle: ''
                })
            }),
            /*#__PURE__*/ _jsx(Screen, {
                name: "SignUp",
                component: SignUp,
                options: _object_spread_props(_object_spread({}, options), {
                    headerShown: false
                })
            }),
            /*#__PURE__*/ _jsx(Screen, {
                name: "ResetPassword",
                component: ResetPassword,
                options: _object_spread_props(_object_spread({}, options), {
                    headerShown: false,
                    title: $t({
                        id: 'ResetPassword_title',
                        defaultMessage: 'Reset password'
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Screen, {
                name: "RequestResetPassword",
                component: RequestResetPassword,
                options: _object_spread_props(_object_spread({}, options), {
                    headerTitle: $t({
                        id: 'RequestResetPassword_title',
                        defaultMessage: 'Forgot password'
                    })
                })
            })
        ]
    });
}
